import { Routes } from '@angular/router';
import {LoginComponent} from "./auth/components/login/login.component";
import {LogoutComponent} from "./auth/components/logout/logout.component";
import {authGuardFn} from "./auth/services/auth.guard";
import {NotAuthorizedComponent} from "./auth/components/not-authorized/not-authorized.component";
import {AuthAccountDetailsComponent} from "./auth/components/auth-account-details/auth-account-details.component";
import {ResetPasswordComponent} from "./auth/components/reset-password/reset-password.component";
import {RagDashboardComponent} from "./rag/rag-dashboard/rag-dashboard.component";
import {TemplatingListComponent} from "./rag/templating/templating-list/templating-list.component";
import {TemplatingManageComponent} from "./rag/templating/templating-manage/templating-manage.component";
import {TemplatingPreviewComponent} from "./rag/templating/templating-preview/templating-preview.component";
import {TemplatingDeleteComponent} from "./rag/templating/templating-delete/templating-delete.component";
import {SessionsListComponent} from "./rag/sessions/sessions-list/sessions-list.component";
import {SessionPreviewComponent} from "./rag/sessions/session-preview/session-preview.component";
import {SessionDeleteComponent} from "./rag/sessions/session-delete/session-delete.component";
import {SessionManageComponent} from "./rag/sessions/session-manage/session-manage.component";
import {SessionChatComponent} from "./rag/sessions/session-chat/session-chat.component";
import {ChatbotsListComponent} from "./rag/chatbots/chatbots-list/chatbots-list.component";
import {ChatbotPreviewComponent} from "./rag/chatbots/chatbot-preview/chatbot-preview.component";
import {ChatbotConfigureComponent} from "./rag/chatbots/chatbot-configure/chatbot-configure.component";
import {ChatbotContextVarComponent} from "./rag/chatbots/chatbot-context-var/chatbot-context-var.component";
import {
  ChatbotContextDashboardComponent
} from "./rag/chatbots/chatbot-context-dashboard/chatbot-context-dashboard.component";
import {
  SessionChatMessageDetailsComponent
} from "./rag/sessions/session-chat-message-details/session-chat-message-details.component";
import {TenantsListComponent} from "./rag/tenants/tenants-list/tenants-list.component";
import {TenantPreviewComponent} from "./rag/tenants/tenant-preview/tenant-preview.component";
import {UsersListComponent} from "./rag/users/users-list/users-list.component";
import {UserPreviewComponent} from "./rag/users/user-preview/user-preview.component";
import {UserDeleteComponent} from "./rag/users/user-delete/user-delete.component";
import {UserManageComponent} from "./rag/users/user-manage/user-manage.component";
import {AuthExternalGoogleComponent} from "./auth/components/auth-external-google/auth-external-google.component";
import {
  ChatbotContextVarTrainComponent
} from "./rag/chatbots/chatbot-context-var-train/chatbot-context-var-train.component";

export const routes: Routes = [
  {
    path: 'auth',
    component: LoginComponent,
    data: {
      title: 'Authenticate',
      hideHeader: true
    }
  },
  {
    path: 'auth/google',
    component: AuthExternalGoogleComponent,
    data: {
      title: 'External Authentication using Google',
      hideHeader: true
    }
  },
  {
    path: 'auth/logout',
    component: LogoutComponent,
    data: {
      title: 'Log Out',
      hideHeader: true
    },
    canActivate: [authGuardFn]
  },
  {
    path: 'auth/not-authorized',
    component: NotAuthorizedComponent,
    data: {
      title: 'Not Authorized',
    },
    canActivate: [authGuardFn]
  },
  {
    path: 'account',
    component: AuthAccountDetailsComponent,
    data: {
      title: 'Account Info',
    },
    canActivate: [authGuardFn],
  },
  {
    path: 'account/reset-password',
    component: ResetPasswordComponent,
    data: {
      title: 'Reset Password',
    },
    canActivate: [authGuardFn],
  },

  {
    path: '',
    component: RagDashboardComponent,
    data: {
      title: 'RAG Space',
    },
    canActivate: [authGuardFn],
    children: [
    ]
  },
  {
    path: 'chatbots',
    component: ChatbotsListComponent,
    data: {
      title: 'Chatbots',
    },
    canActivate: [authGuardFn],
    children: [
      {
        path: ':chatbotUuid',
        component: ChatbotPreviewComponent,
        data: {
          title: '{{chatbotUuid}}',
        },
        canActivate: [authGuardFn],
        children: [
          {
            path: 'rag-context',
            component: ChatbotContextDashboardComponent,
            data: {
              title: 'Context',
            },
            canActivate: [authGuardFn],
            children: [
              {
                path: ':contextVar',
                component: ChatbotContextVarComponent,
                data: {
                  title: '{{contextVar}}',
                },
                canActivate: [authGuardFn],
                children: [
                  {
                    path: 'train',
                    component: ChatbotContextVarTrainComponent,
                    data: {
                      title: 'Train',
                    },
                    canActivate: [authGuardFn],
                  }
                ]
              }
            ]
          },
        ]
      },
      {
        path: ':chatbotUuid/config',
        component: ChatbotConfigureComponent,
        data: {
          title: 'Configure',
        },
        canActivate: [authGuardFn],
        children: [
        ]
      },
    ]
  },
  {
    path: 'templates',
    component: TemplatingListComponent,
    data: {
      title: 'Templates',
    },
    canActivate: [authGuardFn],
    children: [
      {
        path: 'preview/:templateId',
        component: TemplatingPreviewComponent,
        data: {
          title: 'View',
        },
        canActivate: [authGuardFn],
        children: [
        ]
      },
      {
        path: 'delete/:templateId',
        component: TemplatingDeleteComponent,
        data: {
          title: 'Confirm Delete',
        },
        canActivate: [authGuardFn],
        children: [
        ]
      },
      {
        path: 'manage',
        component: TemplatingManageComponent,
        data: {
          title: 'Create',
        },
        canActivate: [authGuardFn],
        children: [
        ]
      },
      {
        path: 'manage/:templateId',
        component: TemplatingManageComponent,
        data: {
          title: 'Modify',
        },
        canActivate: [authGuardFn],
        children: [
        ]
      },
    ]
  },
  {
    path: 'sessions',
    component: SessionsListComponent,
    data: {
      title: 'Sessions',
    },
    canActivate: [authGuardFn],
    children: [
      {
        path: 'preview/:sessionId',
        component: SessionPreviewComponent,
        data: {
          title: '{{sessionId}}',
        },
        canActivate: [authGuardFn],
        children: [
          {
            path: 'chat',
            component: SessionChatComponent,
            data: {
              title: 'Chat',
              breadcrumbsNgClass: 'mb-0'
            },
            canActivate: [authGuardFn],
            children: [
              {
                outlet: 'sidePanel',
                path: 'inspect/:messageId',
                component: SessionChatMessageDetailsComponent,
                data: {
                  title: 'Inspect',
                  breadcrumbsNgClass: 'mb-0'
                },
                canActivate: [authGuardFn],
                children: [
                ]
              },
            ]
          },
        ]
      },
      {
        path: 'delete/:sessionId',
        component: SessionDeleteComponent,
        data: {
          title: 'Confirm Delete',
        },
        canActivate: [authGuardFn],
        children: [
        ]
      },
      {
        path: 'manage',
        component: SessionManageComponent,
        data: {
          title: 'Create',
        },
        canActivate: [authGuardFn],
        children: [
        ]
      },
    ]
  },
  {
    path: 'users',
    component: UsersListComponent,
    data: {
      title: 'Users',
      authorizedRoles: ['Super'],
      requiredClaims: [{
        type: 'system', value: true
      }]
    },
    canActivate: [authGuardFn],
    children: [
      {
        path: 'preview/:userId',
        component: UserPreviewComponent,
        data: {
          title: '{{userId}}',
        },
        canActivate: [authGuardFn],
        children: [
        ]
      },
      {
        path: 'delete/:userId',
        component: UserDeleteComponent,
        data: {
          title: 'Confirm Delete',
        },
        canActivate: [authGuardFn],
        children: [
        ]
      },
      {
        path: 'manage',
        component: UserManageComponent,
        data: {
          title: 'Create',
        },
        canActivate: [authGuardFn],
        children: [
        ]
      },
      {
        path: 'manage/:userId',
        component: UserManageComponent,
        data: {
          title: 'Modify',
        },
        canActivate: [authGuardFn],
        children: [
        ]
      },
    ]
  },
  {
    path: 'tenants',
    component: TenantsListComponent,
    data: {
      title: 'Tenants',
      authorizedRoles: ['Super'],
      requiredClaims: [{
        type: 'system', value: true
      }]
    },
    canActivate: [authGuardFn],
    children: [
      {
        path: 'preview/:tenantId',
        component: TenantPreviewComponent,
        data: {
          title: '{{tenantId}}',
        },
        canActivate: [authGuardFn],
        children: [
        ]
      },
      {
        path: 'delete/:templateId',
        component: TemplatingDeleteComponent,
        data: {
          title: 'Confirm Delete',
        },
        canActivate: [authGuardFn],
        children: [
        ]
      },
      {
        path: 'manage',
        component: TemplatingManageComponent,
        data: {
          title: 'Create',
        },
        canActivate: [authGuardFn],
        children: [
        ]
      },
      {
        path: 'manage/:templateId',
        component: TemplatingManageComponent,
        data: {
          title: 'Modify',
        },
        canActivate: [authGuardFn],
        children: [
        ]
      },
    ]
  },
];
